
import React, { useState, useEffect } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// Removed Firestore imports
import { ApiService } from "../../services/api_service";
import useAuth from "../../hooks/use_auth";


const MyProfile = () => {
  const user = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    state: "",
    gender: "",
    about: "",
  });

  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
      if (user?.uid) {
        try {
          const response = await ApiService.getSingleUser(user.uid);
          const userData = response.data || response; // Handle API response structure
          if (userData) {
            setFormData(prev => ({
              ...prev,
              name: userData.name || "",
              email: userData.email || "",
              phone: userData.phone || "",
              // Add other fields if they exist in backend UserData model
              // Note: UserData model in doc doesn't show country/state/gender/about.
              // Assuming the backend stores them if passed, or we only fetch what is available.
              // For now, mapping what we can.
              // If backend doesn't support these extra fields, they won't persist.
            }));
          }
        } catch (error) {
          console.error("Error fetching user profile:", error);
        }
      }
    };
    fetchUserData();
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (user?.uid) {
      try {
        await ApiService.updateUser(user.uid, formData);
        setIsEditing(false);
        alert("Profile updated successfully!");
      } catch (error) {
        console.error("Error updating profile:", error);
        alert("Failed to update profile.");
      }
    }
  };

  return (
    <div className="bg-[#111111] min-h-screen flex items-center justify-center font-poppins pt-20 sm:pt-24">
      <div className="bg-[#1E1E1E] w-full max-w-[1200px] rounded-2xl px-4 sm:px-6 md:px-8 py-6 sm:py-8 mx-4">
        <div className="flex items-center justify-between mb-10">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-[#343434] flex items-center justify-center text-white text-xl font-semibold uppercase">
              {formData.name ? formData.name[0] : "U"}
            </div>
            <div>
              <p className="text-white font-semibold text-lg">
                {formData.name || "Garvit Kumar Verma"}
              </p>
              <p className="text-gray-400 text-sm">
                {formData.email || "urgarvit@gmail.com"}
              </p>
            </div>
          </div>
          <button className="bg-[#17BD3B] text-white px-5 py-2 rounded-lg hover:bg-[#15a834] transition-colors duration-300">
            Edit Profile
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
          <div>
            <label className="block text-white mb-1 text-xs sm:text-sm">Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full bg-[#202020] text-white border border-[#727274] rounded-md px-3 sm:px-4 py-2 text-sm sm:text-base placeholder-gray-500"
            />
          </div>

          <div>
            <label className="block text-white mb-1 text-xs sm:text-sm">Email</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full bg-[#202020] text-white border border-[#333] rounded-md px-3 sm:px-4 py-2 text-sm sm:text-base placeholder-gray-500"
            />
          </div>

          <div>
            <label className="block text-white mb-1 text-xs sm:text-sm">Phone Number</label>
            <input
              type="text"
              name="phone"
              placeholder="Enter your Phone Number"
              value={formData.phone}
              onChange={handleChange}
              className="w-full bg-[#202020] text-white border border-[#EB4848] rounded-md px-3 sm:px-4 py-2 text-sm sm:text-base placeholder-gray-500"
            />
            {/* <p className="text-[#F07676] text-xs mt-1">Message will be here</p> */}
          </div>

          <div>
            <label className="block text-white mb-1 text-xs sm:text-sm">Gender</label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="w-full bg-[#202020] text-white border border-[#333] rounded-md px-3 sm:px-4 py-2 text-sm sm:text-base"
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div>
            <label className="block text-white mb-1 text-xs sm:text-sm">Country</label>
            <select
              name="country"
              value={formData.country}
              onChange={handleChange}
              className="w-full bg-[#202020] text-white border border-[#333] rounded-md px-3 sm:px-4 py-2 text-sm sm:text-base"
            >
              <option value="">Select Country</option>
              <option value="india">India</option>
              <option value="us">USA</option>
              <option value="uk">UK</option>
            </select>
          </div>

          <div>
            <label className="block text-white mb-1 text-xs sm:text-sm">State</label>
            <input
              type="text"
              name="state"
              placeholder="Enter your State"
              value={formData.state}
              onChange={handleChange}
              className="w-full bg-[#202020] text-white border border-[#333] rounded-md px-3 sm:px-4 py-2 text-sm sm:text-base placeholder-gray-500"
            />
          </div>
        </div>
        <div className="w-full bg-[#1E1E1E] py-3 sm:py-4">
          <label className="block text-white mb-1 text-xs sm:text-sm">About You</label>

          <textarea
            name="about"
            value={formData.about || ""}
            onChange={handleChange}
            rows={4}
            className="w-full bg-[#202020] text-white border border-gray-600 rounded-md px-3 sm:px-4 py-3 sm:py-4 text-sm sm:text-base placeholder-gray-500 resize-none"
            placeholder="Write something about yourself..."
          />
        </div>

      </div>
    </div>
  );
};

export default MyProfile;







